import { t, useTolgeeUpdates } from 'i18n';
import { FC } from 'react';
import { AutoIcon } from './icons/Auto';
import { MoonIcon } from './icons/Moon';
import { SunIcon } from './icons/Sun';
import { tThemePreference } from './themeConfig';

export interface IThemeOption {
  value: tThemePreference;
  label: string;
  Icon: FC;
}

interface IThemeToggle {
  options: IThemeOption[];
}

const SCOPE = 'frontend.member.settings.pages.sound_and_visual';

/** Shared by the profile-menu appearance switch and the settings appearance row. */
export const useThemeToggle = (): IThemeToggle => {
  useTolgeeUpdates();

  const options: IThemeOption[] = [
    {
      value: 'light',
      label: t(`${SCOPE}.light_theme`, { defaultValue: 'Light theme' }),
      Icon: SunIcon
    },
    {
      value: 'dark',
      label: t(`${SCOPE}.dark_theme`, { defaultValue: 'Dark theme' }),
      Icon: MoonIcon
    },
    {
      value: 'system',
      label: t(`${SCOPE}.system_theme`, { defaultValue: 'Automatic' }),
      Icon: AutoIcon
    }
  ];

  return { options };
};
